<template>
  <div class="admin col-12">
    <div class="row">
      <div class="col-3">
        <div class="row">
          <div class="col-12 row-header">Plant Variety</div>
        </div>
        <div class="scrolling-table" v-show="!loading">
          <template v-for="temp in plant_botanys">
            <div
              class="row clickable"
              :key="temp.id"
              v-show="temp.active == !show_deleted"
              v-bind:class="{selected: temp == item}"
              @click="_itemSelected(temp)"
            >
              <div class="col-12">
                {{ temp.description }}
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-9">
        <div class="row">
          <PlantVarietyDetail
            :selectedItem="item"
            class="col-12"
            v-show ="showPlantVarietyDetail"
            ref="plant_botany"
            @new="_new_item"
          />
        </div>
      </div>
    </div>

    <CreatePlantVariety 
    ref="plant_variety_modal" 
    v-show="showCreatePlantVariety" 
    @close="_closeNewModal" 
    />
    
    <div class="row">
      <div class="col-3">
        <input type="checkbox" id="show_deleted" @click="_show_deleted" />
        <label for="show_deleted">Show Deleted</label>
      </div>
    </div>
  </div>
</template>

<script>
import PlantVarietyDetail from "@/components/admin/inventory/detail/PlantVarietyDetail.vue";
import CreatePlantVariety from "@/components/admin/inventory/create/CreatePlantVariety.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "ManagePlantVariety",

  // DATA
  data: () => ({
    item: null,
    loading: false,
    show_deleted: false,
    showCreatePlantVariety: false,
    showPlantVarietyDetail: true,
  }),

  // COMPUTED
  computed: {
    ...mapState("inventory",["plant_botanys","new_plant_botany"]) // inventory.js
  },

  // MOUNTED
   mounted() {
    this.$nextTick(() => {
      this.getPlantBotanys();
    });
  },

  // WATCH
  watch: {
    new_plant_botany(new_value) {
      this.item = new_value;
      this.$refs.plant_variety_modal.clear();
    },
  },

  // METHODS
  methods: {
    ...mapActions("inventory", ["apiCreatePlantBotany","getPlantBotanys"]),

    _show_deleted() {
      this.show_deleted = !this.show_deleted;
    },

    _save() {
      this.$refs.plant_botany.save();
    },

    _new_item() {
      this.showCreatePlantVariety = true;
    },

    _closeNewModal() {
      this.showCreatePlantVariety = false;
    },
  
    _showTab(index) {
      this.tab = index;
    },

    _itemSelected(item) {
      this.item = item;
      this.showPlantVarietyDetail = true;
    },

    _delete_item() {
      if (this.item != null && this.item.id > 0) {
        this.item.active = !this.item.active;
        this.apiSavePlantBotany(this.item);
      }
    },
  },

  // COMPONENTS
  components: {
    PlantVarietyDetail,
    CreatePlantVariety,
  },
};
</script>
